<template xmlns:div="http://www.w3.org/1999/html">
    <div>
        <section>
            <div class="wrapper__home">
                <div class="logo__wrapper">
                    <a class="logo" href="/">
                        <img src="../assets/images/logo.svg" alt="CiBeez-logo"/>
                    </a>
                </div>
                <div class="wrapper__text__home">
                    <div class="container">
                        <div class="row">
                            <div class="col-sm-12 col-md-12 col-lg-2 col-xl-2">

                            </div>
                            <div class="col-sm-12 col-md-12 col-lg-8 col-xl-8">
                                <h1 data-aos="fade" >Cibeez - The Delivery Network</h1>
                            </div>
                            <div class="col-sm-12 col-md-12 col-lg-2 col-xl-2">

                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12 col-md-12 col-lg-2 col-xl-2">

                            </div>
                            <div class="col-sm-12 col-md-12 col-lg-8 col-xl-8">
                                <div data-aos="fade"  data-aos-duration="2000" class="about-home">
                                    A powerful multi-carrier delivery network, connecting retailers and carriers through
                                    a
                                    cutting-edge
                                    platform, addressing last-mile challenges and providing superior customer experience
                                    and
                                    service
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-12 col-lg-2 col-xl-2"></div>
                        </div>
                    </div>
                </div>
                <div class="scroll__wrapper">
                    <a href="#" v-scroll-to="'#element'" class="scroll-down"></a>
                </div>
            </div>
        </section>
        <section>
            <div id="element" class="wrapper__integrated">
                <div class="container">
                    <div class="row">
                        <div class="col-sm-12 col-md-12 col-lg-2 col-xl-2">

                        </div>
                        <div data-aos="fade" data-aos-duration="3000"   class="col-sm-12 col-md-12 col-lg-8 col-xl-8">
                            <div class="title-raves">
                                Cibeez customer raves
                            </div>
                            <div  class="title-integrated">
                                “Cibeez's integrated, intelligent solution has completely revolutionized the way we do
                                business and think e-Logistics”
                            </div>
                            <div class="about-location">
                                Eran Toledano, Head of e-Commerce at Super-Pharm - a leading Pharmacy, drugstore retail
                                chain in Israel operating also in Poland and China
                            </div>

                        </div>
                        <div class="col-sm-12 col-md-12 col-lg-2 col-xl-2">

                        </div>
                    </div>
                </div>
                <div class="scroll__wrapper">
                    <a href="#" v-scroll-to="'#element2'" class="scroll-down scroll-down2"></a>
                </div>
            </div>
        </section>
    </div>

</template>

<script>
    export default {}
</script>
